<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<div class="d-flex align-center mr-2" style="flex: 1;max-width: 120px;">
				<!-- <v-select
					v-model="sort_by"
					:items="sortByItems"
					:menu-props="{ top: true, offsetY: true }"
					item-text="text"
					item-value="value"
					label="Ordenar Por"
					class="custom-height-search custom-height-calendar"
					outlined
					dense
					required
				>
				</v-select> -->
				<v-menu v-model="sortByMenu" :offset-y="true" :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn text class="table-header-button d-flex flex-row pa-0 justify-start" block style="height: auto;"
							v-bind="attrs"
							v-on="on">
							<p class="mb-0 font-weight-bold body-2 text-capitalize">Ordenar Por</p>
							<v-icon small class="ml-2">mdi-sort</v-icon>
						</v-btn>
					</template>

					<v-list dense class="filter-selector-list">
						<v-list-item dense style="min-height: auto;">
							<div style="width: 100%" class="mb-2">
								<p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Ordenar Por:</p>
								<v-divider></v-divider>
							</div>
						</v-list-item>
						<v-list-item-group v-model="sort_by">
							<v-list-item
								style="min-height: auto;"
								v-for="(item, index) in sortByItems"
								:key="index"
								:value="item.value">
								<template v-slot:default="{ active }">
									<v-list-item-title class="my-0 d-flex flex-row align-center">
										<v-checkbox
											dense
											hide-details
											color="#959595"
											class="caption my-0 py-0"
											:input-value="active"></v-checkbox>
										<p class="mb-0 caption">{{item.text}}</p>
									</v-list-item-title>
								</template>
							</v-list-item>
						</v-list-item-group>
						<v-divider class="my-1"></v-divider>
						<v-list-item-group v-model="sort_by_direction">
							<v-list-item
								style="min-height: auto;"
								v-for="(item, index) in sortByDirection"
								:key="index"
								:value="item.value">
								<template v-slot:default="{ active }">
									<v-list-item-title class="my-0 d-flex flex-row align-center">
										<v-checkbox
											dense
											hide-details
											color="#959595"
											class="caption my-0 py-0"
											:input-value="active"></v-checkbox>
										<p class="mb-0 caption">{{item.text}}</p>
									</v-list-item-title>
								</template>
							</v-list-item>
						</v-list-item-group>
						<v-list-item dense style="min-height: auto;">
							<v-btn x-small block color="#959595" dark class="mt-2" @click="reloadInfo()">
								<p class="mb-0 caption">Aplicar Orden</p>
							</v-btn>
						</v-list-item>
					</v-list>
				</v-menu>
			</div>
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.contracts.loadingCompanyClients"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.users.companyClientsCount"
				:loading-info="$store.state.users.loadingCompanyClients"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				:headers="headers"
				:items="$store.state.users.companyClients"
				:server-items-length="$store.state.users.companyClientsCount"
				:search="search"
				item-key="id"
				:loading="$store.state.users.loadingCompanyClients"
				:options.sync="options"
				class="crm-table"
				loading-text="Cargando datos..."
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.client="{ item }">
					<div class="d-flex align-center">
						<v-avatar
							size="30"
						>
							<img :src="item.profile?.avatar" class="user-avatar" v-if="item.profile?.avatar"/>
							<v-icon v-else class="user-avatar icon" color="#524D4D" x-large>mdi-account</v-icon>
						</v-avatar>
						<div class="d-flex flex-column flex-grow-1">
							<p class="ml-2 mb-0 font-weight-bold">{{ item.profile?.name }} {{ item.profile?.lastname }} {{ item.profile?.second_lastname }}</p>
							<p class="ml-2 mb-0 caption">{{ item.email }} | {{ item.profile?.phone }}</p>
						</div>
						<div class="d-flex flex-column align-end justify-start">
							<v-tooltip bottom v-if="item.company_profile && item.accreditation?.status">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#FF1209"
										v-bind="attrs"
										v-on="on">mdi-domain</v-icon>
								</template>
								<span>Cliente Empresa</span>
							</v-tooltip>
							<v-tooltip bottom v-else>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#959595"
										v-bind="attrs"
										v-on="on">mdi-account</v-icon>
								</template>
								<span>Cliente Persona Natural</span>
							</v-tooltip>
							<v-chip
								color="green"
								label
								outlined
								x-small
								class="mt-1"
								v-if="$store.state.users.companyClientsRecentsId.includes(item.id)"
							>
								<b>Nuevo Cliente</b>
							</v-chip>
						</div>
					</div>
				</template>
				<template v-slot:item.created_at="{ item }">
					<div class="d-flex align-center">
						<p class="ml-2 mb-0">{{ item.created_at | toDate }}</p>
					</div>
				</template>
				<template v-slot:item.last_activity_date="{ item }">
					<div class="text-center d-flex align-center" v-if="sort_by == 'last_project_date'">
						<p class="ml-2 mb-0">{{ item.last_activity_date | toDateTime }}</p>
					</div>
					<div class="text-center" v-else>--</div>
				</template>
				<template v-slot:item.address="{ item }">
					<div class="d-flex flex-column flex-grow-1">
						<p class="ml-2 mb-0">{{ item.profile?.address }}</p>
						<p class="ml-2 mb-0">{{ item.profile?.city?.name }}</p>
					</div>
				</template>
				<template v-slot:item.project_type="{ item }">
					<div class="d-flex align-center">
						<p class="ml-2 mb-0">{{ item.preprojects[0]?.info?.project_type?.name }}</p>
					</div>
				</template>
				<template v-slot:item.actions="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="#959595"
								class="mx-1"
								@click.stop="() => { selectRow(item); toClientDetail(item); }"

								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-clipboard-account-outline</v-icon>
							</v-btn>
						</template>
						<span>Ver ficha cliente</span>
					</v-tooltip>
					<v-tooltip bottom v-if="$checkPermissions(['edit_users'])">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="warning"
								class="mx-1"
								@click.stop="() => { selectRow(item); editUser(item); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-pencil-outline</v-icon>
							</v-btn>
						</template>
						<span>Editar</span>
					</v-tooltip>
					<!-- <v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								dark
								x-small
								color="#31D56A"
								class="mx-1"
								@click.stop="() => { selectRow(item); $router.push({ name: 'Chat', query: { user_id: item.id } }); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-chat-outline</v-icon>
							</v-btn>
						</template>
						<span>Chatear</span>
					</v-tooltip> -->
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.users.companyClientsCount"
				:loading-info="$store.state.users.loadingCompanyClients"
			/>
		</div> -->
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'Clients',
	components: {
		DataTablePagination,
	},
  data() {
    return {
      search: '',
			selectedRowItem: null,
			searchInput: null,
			sortByMenu: false,
			sort_by: 'client',
			sort_by_direction: 'asc',
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [],
      },
			sortByItems: [
				{text: 'Cliente', value: 'client'},
				{text: 'Fecha Ingreso', value: 'created_at'},
				{text: 'Fecha Último Proyecto', value: 'last_project_date'}
			],
			sortByDirection: [
				{text: 'Ascendente', value: 'asc'},
				{text: 'Descendente', value: 'desc'}
			],
      headers: [
        { text: 'Cliente', value: 'client', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Dirección', value: 'address', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Tipo Proyecto', value: 'project_type', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Fecha Ingreso', value: 'created_at', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Fecha Último Proyecto', value: 'last_activity_date', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Acciones', value: 'actions', align: 'center', width: 100, sortable: false },
      ],
    };
  },
  computed: {
    filteredUsers() {
      return this.$store.state.users.usersList.filter(user => {
        return (
          user.name.toLowerCase().includes(this.search.toLowerCase()) ||
          user.email.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
    options: {
      handler() {
				console.log(this.options)
				this.reloadInfo()
      },
      deep: true,
    },
		// sort_by(newValue){
		// 	if(newValue){
		// 		this.reloadInfo()
		// 	}
		// },
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_clients_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
	},
  methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.reloadInfo(this.searchInput)
		},
		reloadInfo(search = null){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
				sort_by: this.sort_by,
				sort_by_direction: this.sort_by_direction
			}
			if(search){
				data = {search}
			}
			this.sortByMenu = false
			this.$store.dispatch('users/getCompanyClients', data)
		},
		toClientDetail(item){
			this.$router.push({ name: 'Client', params: { id: item.id } })
		},
    editUser(user) {
			const data = {...user, ...{user_id: user.id, client: true}}
			this.$store.commit('users/setNewUserModalEditing', data)
			this.$store.commit('users/setNewUserModal', true)
    },
  },
};
</script>

<style scoped>
.crm-table table tr td{
	font-size: 11px!important;
}
.crm-table.resizable .v-data-table__wrapper th,
.crm-table.resizable .v-data-table__wrapper td {
	border-right: 1px solid #cacaca;
}
</style>
<style>

.with-divider {
  border-right: 1px solid grey;
}
</style>